import { createPortal } from 'react-dom';
import { Toast } from 'react-bootstrap';
import styles from './Toaster.module.scss';

export default function Toaster({
  successMsg,
  errorMsg,
  onClearSuccess,
  onClearError,
}) {
  return createPortal(
    <div
      className={styles.toastPortal}
      aria-live="polite"
      aria-atomic="true"
    >
      {successMsg && (
        <Toast
          className={`shadow border-0 ${styles.toastSuccess}`}
          onClose={onClearSuccess}
          show
          delay={3000}
          autohide
        >
          <Toast.Body className="text-center">{successMsg}</Toast.Body>
        </Toast>
      )}

      {errorMsg && (
        <Toast
          className={`shadow border-0 ${styles.toastError}`}
          onClose={onClearError}
          show
          delay={4000}
          autohide
        >
          <Toast.Body className="text-center">{errorMsg}</Toast.Body>
        </Toast>
      )}
    </div>,
    document.body
  );
}
